// JavaScript to be fired on the template-flexible page
export default {
    init() {

        this.modalVideo = $('.modal--video')
        this.sliderColumns = $('.slider-columns-wrap')
        this.colSliderLeft = $('.slider-columns')
        this.colSliderRight = $('.slider-columns-content')
        this.colSliderNav = $('.slider-columns-nav')

        if (this.modalVideo.length) {
            this.autoPlayVideo()
        }

        if (this.sliderColumns.length) {
            this.columnsSlider()
        }

    },
    autoPlayVideo() {

        this.modalVideo.on('shown.bs.modal', (e) => {
            const video = $(e.target).find('video')
            if (video.length) {
                video[0].play()
            }
        })

        this.modalVideo.on('hide.bs.modal', (e) => {
            const video = $(e.target).find('video')
            if (video.length) {
                video[0].pause()
            }
        })

    },
    columnsSlider() {

        this.colSliderLeft.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-columns-content',
            rows: 0,
        })

        this.colSliderRight.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-columns',
            rows: 0,
            swipe: false,
        })

        this.colSliderNav.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
            arrows: false,
            fade: true,
            rows: 0,
            swipe: false,
        })

        $('.slider-columns-prev').click( () => {
            this.colSliderPrev()
        })

        $('.slider-columns-next').click( () => {
            this.colSliderNext()
        })

        const self = this

        this.colSliderLeft.on('swipe', function(event, slick, direction){
            if (direction == 'right') {
                self.colSliderNext()
            } else if (direction == 'left') {
                self.colSliderPrev()
            }
        })

    },
    colSliderPrev() {
        this.colSliderLeft.slick('slickPrev')
        this.colSliderRight.slick('slickPrev')
        this.colSliderNav.slick('slickPrev')
    },
    colSliderNext() {
        this.colSliderLeft.slick('slickNext')
        this.colSliderRight.slick('slickNext')
        this.colSliderNav.slick('slickNext')
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/flex.js